import { ConstraintValidator, ConstraintValue } from '../index';
import useConstraintValidatorHelper from './constaintValidatorHelper';

export interface MaxLengthConstraintValidator extends ConstraintValidator<number> {
}

export default function useMaxLengthConstraintValidator(): MaxLengthConstraintValidator {

  const getName = () => {
    return 'maxLength';
  };

  const helperFactory = useConstraintValidatorHelper<number>();

  const validate = (
    object: Record<string, any>,
    fieldName: string,
    constraintConfiguration: ConstraintValue<number>,
  ): boolean => {

    const helper = helperFactory.createHelper(
      object,
      fieldName,
      constraintConfiguration,
    );
    const value = helper.getValue();

    if (helper.hasValue()) {
      const constraintValue = helper.getConstraintValue();
      if (typeof value === 'string') {
        return value.length <= constraintValue;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const getErrorMessage = (config: ConstraintValue<number>) => {
    return (typeof config === 'object' && config.message)
      || `Field length should not be greater than ${config}`;
  };

  return {
    getName,
    validate,
    getErrorMessage,
  };
}
